//-------------imports---------------
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useTheme } from "@mui/material/styles";
import { useSelector } from "react-redux";
import {
  Box,
  Grid,
  Breadcrumbs,
  Link,
  TextField,
  Stack,
  Button,
  AppBar,
  Autocomplete,
  CircularProgress,
} from "@mui/material";
import {
  AddCircle as AddCircleIcon,
  BorderColorOutlined as BorderColorOutlinedIcon,
  NavigateNext as NavigateNextIcon,
} from "@mui/icons-material";

import Navbar from "../../components/common/Navbar";
import ViewData from "../../components/grids/ViewDatagrid";
import { useStyles } from "../../assets/styles/Theme";
import { OtherChargesdata } from "../../assets/Griddata";
import { currencyFormatLKR } from "../../utils/common/CurrencyFormat";
import { externalgetApi } from "../../services/external/externalApis";
import { SETTINGS_API_19, SETTINGS_API_22 } from "../../api/ApiModel";
import {
  CON_CAT_TYPE_POS,
  CON_CAT_TYPE_RESTAURANT,
  CON_STATUS_ACTIVE,
} from "../../utils/sys/Constants";
import SearchAppBar from "../../components/common/search";

function ViewOtherChanges() {
  //-----------hooks-------------
  const navigate = useNavigate();
  const theme = useTheme();
  const styles = useStyles(theme);

  // Redux state
  const SYS_USER = useSelector((state) => state.user) || {};
  const { COMPCODE, LOCCODE, RESTCODE, CATTYPE } = SYS_USER.USER_PARAM || {};

  // State variables
  const [data, setData] = useState(null);
  const [data1, setData1] = useState(null);
    const [searchText, setSearchText] = useState("");
      const [filteredRows, setFilteredRows] = useState([]);
    
  const [dropdownOptions, setDropdownOptions] = useState([]);
  const [selectedOrderType, setSelectedOrderType] = useState(null);
  const [error, setError] = useState(null);

  // Fetch  data based on order type
  const fetchData = async (orderTypeCode) => {
    try {
      const result = await externalgetApi(SETTINGS_API_19, "get", {
        COMPCODE,
        LOCCODE,
        RESTCODE,
        STS: CON_STATUS_ACTIVE,
        ORDERTYPECODE: orderTypeCode,
      });
      setData(result);
      setFilteredRows(result)
    } catch (err) {
      setError(err);
      console.error("Error fetching data:", err);
    }
  };

  // Fetch dropdown options for order types
  useEffect(() => {
    const fetchDropdownData = async () => {
      try {
        const result = await externalgetApi(SETTINGS_API_22, "get", {
          CATTYPE,
          STS: CON_STATUS_ACTIVE,
        });

        setData1(result);

        if (result && result.length > 0) {
          // Set the first item as the default selection
          setSelectedOrderType(result[0].ORDERTYPE);
          await fetchData(result[0].ORDERTYPECODE); // Fetch data for default order type
        }
      } catch (err) {
        setError(err);
        console.error("Error fetching dropdown options:", err);
      }
    };

    fetchDropdownData();
  }, []);

   useEffect(() => {
      if (data) {
        const filtered = data.filter(
          (item) =>
            item.CHARGETYPE.toLowerCase().includes(searchText.toLowerCase())
        );
        setFilteredRows(filtered);
      }
    }, [searchText, data]);
  //--------------------------------functions-----------------
  // Handle changes in the order type dropdown
  // Handle changes in the order type dropdown
  const handleOrderTypeChange = async (event, newValue) => {
    if (newValue) {
      setSelectedOrderType(newValue.ORDERTYPE); // Set selected order type
      await fetchData(newValue.ORDERTYPECODE); // Fetch data dynamically
    } else {
      setSelectedOrderType(null);
      setData(null); // Reset data if no selection
    }
  };

  const handleSearchChange = (event) => {
    setSearchText(event.target.value);
  };

  // Map API result to grid rows
const mapResultToRows = (result) =>
  result.map((item, index) => ({
    id: item.CHARGECODE || index + 1,
    CHARGECODE: item.CHARGECODE,
    CHARGETYPE: item.CHARGETYPE,
    CHARGEFOR:
      item.CHARGEFOR === "G"
        ? "Gross"
        : item.CHARGEFOR === "N"
        ? "Net"
        : item.CHARGEFOR,
    STS: item.STS,
    CHARGERATE: item.CHARGERATE,
  }));

  // Handle item click for edit action
  const handleItemClick = (id, actionText) => {
    // Find the order type object matching the selected order type
    const selectedOrderTypeObj = data1?.find(
      (item) => item.ORDERTYPE === selectedOrderType
    );

    const orderTypeCode = selectedOrderTypeObj?.ORDERTYPECODE || "0"; // Default to "1" if not found

    if (actionText === "Edit") {
      const selectedItem = data?.find((item) => item.CHARGECODE === id);
      navigate("/otherchange", {
        state: {
          selectedItem,
          actionText,
          orderTypeCode,
          orderType: selectedOrderType,
        },
      });
    } else {
      navigate("/otherchange", {
        state: { selectedItem: null, orderTypeCode },
      });
    }
  };

  // Menu items for grid actions
  const menuItems = [
    {
      text: "Edit",
      icon: <BorderColorOutlinedIcon />,
      onClick: (CHARGECODE) => handleItemClick(CHARGECODE, "Edit"),
    },
  ];

  // Grid rows
  const rows = mapResultToRows(data || []);

  return (
    <div>
      <Navbar />
      <AppBar sx={styles.AI_CustomAppBar1}>
        <Box sx={styles.AI_HeaderContainer1}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <Breadcrumbs
                sx={styles.AI_breadcrumbs2}
                separator={<NavigateNextIcon fontSize="small" />}
              >
                <Link underline="none">Home</Link>
                <Link underline="none">Settings</Link>
                <Link underline="none">View Other Charges</Link>
              </Breadcrumbs>
            </Grid>
            <Grid item>
              <Stack
                sx={styles.AI_fixedStack1}
                direction="row"
                justifyContent="flex-end"
                spacing={2}
                padding={1}
              >
                <Autocomplete
                  options={data1 || []}
                  getOptionLabel={(option) => option.ORDERTYPE || ""}
                  value={
                    data1
                      ? data1.find(
                          (option) => option.ORDERTYPE === selectedOrderType
                        ) || null
                      : null
                  } // Add null check for data1
                  onChange={handleOrderTypeChange}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Order Type"
                      fullWidth
                      size="small"
                      sx={{
                        width: "100%",
                        minWidth: 220,
                      }}
                    />
                  )}
                  ListboxProps={{
                    sx: {
                      maxHeight: 150,
                      backgroundColor: theme.palette.background.paper,
                      "& .MuiAutocomplete-option": {
                        "&:hover": {
                        
                        },
                        "&.Mui-focused": {
                          
                          
                        },
                      },
                    },
                  }}
                  noOptionsText="No order types available" // Fallback for empty state
                />
                <SearchAppBar
                                  onChange={handleSearchChange}
                                  value={searchText}
                                />

                <Button
                  onClick={() => navigate("/otherchange")}
                  variant="contained"
                  startIcon={<AddCircleIcon />}
                  sx={{
                    background: theme.palette.primary.main,
                    color: theme.palette.text.buttontxt,
                    textTransform: "capitalize",
                    width: "80px",
                  }}
                >
                  Add
                </Button>
              </Stack>
            </Grid>
          </Grid>
        </Box>
      </AppBar>
      <ViewData
        columns={OtherChargesdata.columns}
        rows={mapResultToRows(filteredRows)}
        tabletitle={OtherChargesdata.name}
        menuItems={menuItems}
        gridid="CHARGECODE"
      />
    </div>    
  );
}

export default ViewOtherChanges;
